var moduleMap = {
	"AiBody": () => {
		return Promise.all([__webpack_require__.e(8688), __webpack_require__.e(2111), __webpack_require__.e(1423), __webpack_require__.e(4624), __webpack_require__.e(6178), __webpack_require__.e(7730), __webpack_require__.e(2114), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(3136), __webpack_require__.e(9772), __webpack_require__.e(4849), __webpack_require__.e(6268), __webpack_require__.e(2042), __webpack_require__.e(1994), __webpack_require__.e(3808), __webpack_require__.e(9733)]).then(() => (() => ((__webpack_require__(64195)))));
	},
	"AiBodyGreetingRemote": () => {
		return Promise.all([__webpack_require__.e(4914), __webpack_require__.e(3136), __webpack_require__.e(2042), __webpack_require__.e(4562)]).then(() => (() => ((__webpack_require__(74562)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});